import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '@env/environment';

export interface OrderInvoicingStatusPayload {
  orderId: string;
  tenantId: string;
}

export interface OrderInvoicingStatusResponse {
  isInvoiced: boolean;
  createdAt?: string;
}

@Injectable({ providedIn: 'root' })
export class OrderInvoicingStatusService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.API_ORDERS}`;

  async getInvoicingStatus(
    payload: OrderInvoicingStatusPayload
  ): Promise<OrderInvoicingStatusResponse> {
    try {
      const url = `${this.baseUrl}/v2/${payload.tenantId}/${payload.orderId}/order-conditions`;
      const response = await firstValueFrom(
        this.http.get<any>(url)
      );
      return {
        isInvoiced: response?.invoicedTracking?.status === 'INVOICED',
        createdAt: response?.invoicedTracking?.createdAt,
      };
    } catch (error) {
      return { isInvoiced: false };
    }
  }
}
